import { Box, Button, Flex, Icon, Image, Text } from '@chakra-ui/react';
import i18next from 'i18next';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImSpinner6 } from 'react-icons/im';
import { useDispatch, useSelector } from 'react-redux';

import useLongMachineSetting from '@/hook/useLongMachineSetting';

import { cancelTransfer } from '../../api/postApi';
import { COMMON_WEB_PATH } from '../../constant';
import ReferQrcode from '../../pages/ReferCode/components/referQrcode';
import { CLEAR_SOCKET_MESSAGE, notice } from '../../redux/action/action';

const ClearCashButTransfer = ({ transCode = '', onCancelClearCash } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [qrcodeModal, setQrcodeModal] = useState(false);
  const [errorScan, setErrorScan] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const isTriggerGivenUpPoint = useSelector(
    (state) => state.isTriggerGivenUpPoint
  );
  const isSocketMessage = useSelector((state) => state.isSocketMessage);
  const isMemberInfo = useSelector((state) => state.isMemberInfo);

  const { cagent_uid } = isMemberInfo || {};

  const { message, show } = isSocketMessage || {};

  const { longMachinePaddingTop } = useLongMachineSetting();

  const handleCloseQrcodeModal = () => {
    dispatch(CLEAR_SOCKET_MESSAGE());
    dispatch({ type: 'GET_BALANCE' });
    setQrcodeModal(false);
    onCancelClearCash();
  };

  //後悔棄分轉點要取消轉移
  const goCancelTransfer = async () => {
    if (isLoading) return; // 防止重複點擊
    setIsLoading(true);

    try {
      await cancelTransfer({ transCode });
      dispatch(
        notice({
          title: i18n('取消點數轉移成功'),
          content: '',
          type: 'success'
        })
      );

      dispatch(CLEAR_SOCKET_MESSAGE());
      dispatch({ type: 'GET_BALANCE' }); //重新取餘額
      setQrcodeModal(false);
      onCancelClearCash();
    } catch (error) {
      dispatch(
        notice({
          title: i18n('取消點數轉移失敗'),
          content: error?.response?.data?.message || i18n('請稍後再試'),
          type: 'error'
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const lineApiVersion2Url = useMemo(() => {
    return `https://liff.line.me/2008392583-EWkzbmbQ?trans_code=${transCode}`;
  }, [transCode, cagent_uid]);

  useEffect(() => {
    if (transCode) {
      setQrcodeModal(true);
    }
  }, [transCode]);

  useEffect(() => {
    if (isTriggerGivenUpPoint) {
      setQrcodeModal(false);
      dispatch(
        notice({
          title: i18n('轉移成功！！'),
          content: '',
          type: 'success'
        })
      );
    }
  }, [isTriggerGivenUpPoint]);

  useEffect(() => {
    //INIT
    dispatch(CLEAR_SOCKET_MESSAGE());
  }, []);

  useEffect(() => {
    if (message && show) {
      setErrorScan(true);
    }
  }, [message, show]);

  return (
    qrcodeModal && (
      <Box
        bg="rgba(0,0,0,0.8)"
        position="fixed"
        top="0"
        left="0"
        w="100%"
        h="100%"
        pt={longMachinePaddingTop}
        display="flex"
        flexDirection="column"
        alignItems={'center'}
        justifyContent={'center'}
        gap={5}
        zIndex={5}
      >
        {!isLoading ? (
          <Text fontSize="xl" fontWeight={700}>
            {i18n('請務必掃描轉移QRCODE！！')}
          </Text>
        ) : null}
        {errorScan ? null : (
          <Flex gap={10} alignItems="center">
            {isLoading ? (
              <Flex alignItems={'center'} justifyContent={'center'}>
                <Icon
                  as={ImSpinner6}
                  fontSize={'30px'}
                  className="animate-spin"
                  color="yellow.500"
                />
              </Flex>
            ) : (
              <Flex direction={'column'} alignItems={'center'} gap={2}>
                <Text>{i18n('LINE登入')}</Text>
                <Box p={2} borderRadius={2} bg="white">
                  <a className="cursor-pointer" href={lineApiVersion2Url}>
                    <ReferQrcode
                      className={{
                        w: '150px',
                        h: '150px'
                      }}
                      value={lineApiVersion2Url}
                    />
                  </a>
                </Box>

                <Box
                  sx={{
                    bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/cancel_button.png) !important`,
                    bgSize: 'contain !important',
                    bgRepeat: 'no-repeat !important',
                    bgPosition: 'center !important',
                    background: 'transparent',
                    _hover: {
                      bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/cancel_button.png)`
                    },
                    _active: {
                      bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/cancel_button.png)`
                    },
                    h: '80px'
                  }}
                  isLoading={isLoading}
                  disabled={isLoading}
                  py="20px"
                  as={Button}
                  onClick={goCancelTransfer}
                  w="180px"
                  display={'flex'}
                  justifyContent={'center'}
                  alignItems={'center'}
                ></Box>
              </Flex>
            )}
          </Flex>
        )}

        {errorScan ? (
          <>
            <Text fontSize="xl" fontWeight={700} color="red.500">
              {i18n(message)}
            </Text>
            <Button variant={'brandPrimary'} onClick={handleCloseQrcodeModal}>
              {i18n('關閉重試')}
            </Button>
          </>
        ) : null}
      </Box>
    )
  );
};

export default ClearCashButTransfer;
